import bg from 'url:../../assets/phck/fm/comedyshowbg.png';
import stage_2 from 'url:../../assets/phck/fm/Stage 2.png';
import cow_jumping from 'url:../../assets/phck/fm/Cow Jumping Over Moon.png';
import audience_4 from 'url:../../assets/phck/fm/Audience 4.png';
import audience_5 from 'url:../../assets/phck/fm/Audience 5.png';
import george_washington from 'url:../../assets/phck/fm/George Washington 10.png';
import acrobat_13 from 'url:../../assets/phck/fm/Acrobat 13.png';
import bouncer from 'url:../../assets/phck/fm/Bouncer.png';
import door_cartoon from 'url:../../assets/phck/fm/Door - Cartoon.png';
import boy_selling from 'url:../../assets/phck/fm/Boy Selling Tomatoes.png';
import trash_can from 'url:../../assets/phck/fm/Trash Can - Cartoon.png';
import chick_standing from 'url:../../assets/phck/fm/Chick Standing.png';
import deer_3 from 'url:../../assets/phck/fm/Deer 3.png';
import cow_17 from 'url:../../assets/phck/fm/Cow 17.png';
import creature_broom from 'url:../../assets/phck/fm/Creature with Broom.png';
import table_candle_2 from 'url:../../assets/phck/fm/Table & Candle 2.png';
import cat_in_boot_2 from 'url:../../assets/phck/fm/Cat in Boot 2.png';
import chicken_2 from 'url:../../assets/phck/fm/Chicken 02.png';
import dancer_47 from 'url:../../assets/phck/fm/Dancer 47.png';
import woman_bird from 'url:../../assets/phck/fm/Woman-Bird 1.png';
import spotlight from 'url:../../assets/phck/fm/Spotlight on Stage.png';
import boom_2 from 'url:../../assets/phck/fm/Boom 2.png';
import boom_1 from 'url:../../assets/phck/fm/Boom 1.png';
import lighting from 'url:../../assets/phck/fm/Lighting Equipment 2.png';
import circus_seal from 'url:../../assets/phck/fm/Circus Seal 2.png';
import table_candle_1 from 'url:../../assets/phck/fm/Table & Candle 1.png';
import clown_sad_2 from 'url:../../assets/phck/fm/Clown - Sad 2.png';
import bear_on_ball from 'url:../../assets/phck/fm/Bear on Ball.png';
import funny_7 from 'url:../../assets/phck/fm/Funny 7.png';
import funny_9 from 'url:../../assets/phck/fm/Funny 9.png';
import fridge from 'url:../../assets/phck/fm/Refrigerator 14.png';
import couple_theater from 'url:../../assets/phck/fm/Couple at Theater.png';
import creature_angry from 'url:../../assets/phck/fm/Creature - Angry 1.png';
import drama_critic from 'url:../../assets/phck/fm/Drama Critic.png';
import skunk from 'url:../../assets/phck/fm/Skunk.png';
import dog_47 from 'url:../../assets/phck/fm/Dog 47.png';
import director_pleased from 'url:../../assets/phck/fm/Director - Pleased.png';
import funny_6 from 'url:../../assets/phck/fm/Funny 6.png';
import buffalo from 'url:../../assets/phck/fm/Buffalo.png';
import funny_8 from 'url:../../assets/phck/fm/Funny 8.png';
import audience_2 from 'url:../../assets/phck/fm/Audience 2.png';
import wall1 from 'url:../../assets/phck/fm/wall1.png';
import wall2 from 'url:../../assets/phck/fm/wall2.png';
import wall3 from 'url:../../assets/phck/fm/wall3.png';
import wall4 from 'url:../../assets/phck/fm/wall4.png';
import { Smashable } from '../../components/cursor/Smashable';

const STD_WIDTH : number = 1920;
const STD_HEIGHT : number = 1371;

export function PCFM () {
    const width = 1920 / 2;
    return <div className="page-basic bg-black v-box">
        <div className='height-64' />
        <div className="pos-rel mask-content" style={{width, height: width * STD_HEIGHT / STD_WIDTH}}>
            <FME src={bg} left={0} top={0} width={100} />
            <FME src={stage_2} left={-0.16} top={0.00} width={58.85} />
            <FME src={wall1} left={9.64} top={33.11} width={10.57} />
            <FME src={wall2} left={20.21} top={35.74} width={10.31} />
            <FME src={wall3} left={30.52} top={35.74} width={10.31} />
            <Smashable><FME src={wall4} left={40.83} top={33.99} width={8.54} /></Smashable>
            <FME src={cow_jumping} left={5.89} top={4.08} width={15.78} />
            <FME src={audience_4} left={76.30} top={19.77} width={22.92} />
            <FME src={audience_5} left={58.28} top={1.90} width={18.02} />
            <FME src={george_washington} left={11.25} top={47.63} width={7.81} />
            <FME src={acrobat_13} left={82.50} top={-3.94} width={14.69} />
            <FME src={bouncer} left={76.61} top={45.95} width={11.88} />
            <FME src={door_cartoon} left={85.16} top={36.25} width={15.89} />
            <FME src={boy_selling} left={64.38} top={42.60} width={12.66} />
            <FME src={trash_can} left={61.67} top={55.65} width={5.57} />
            <FME src={chick_standing} left={90.47} top={51.79} width={5.83} />
            <FME src={deer_3} left={89.84} top={59.88} width={13.02} />
            <FME src={cow_17} left={73.75} top={60.39} width={10.21} />
            <FME src={creature_broom} left={92.29} top={74.18} width={7.40} />
            <FME src={table_candle_2} left={63.59} top={64.33} width={8.33} />
            <FME src={cat_in_boot_2} left={63.54} top={65.28} width={7.19} />
            <FME src={table_candle_2} left={78.02} top={76.95} width={8.33} />
            <FME src={chicken_2} left={69.84} top={75.42} width={3.70} />
            <FME src={dancer_47} left={82.45} top={72.50} width={10.00} />
            <FME src={woman_bird} left={76.15} top={75.49} width={5.36} />
            <FME src={spotlight} left={18.23} top={35.96} width={19.06} />
            <FME src={boom_2} left={25.68} top={49.16} width={18.70} />
            <FME src={boom_1} left={0.00} top={42.16} width={21.77} />
            <FME src={lighting} left={55.26} top={43.69} width={7.08} />
            <FME src={lighting} left={-0.73} top={59.08} width={5.31} />
            <FME src={table_candle_2} left={19.38} top={81.33} width={8.33} />
            <FME src={table_candle_2} left={3.70} top={70.46} width={8.33} />
            <FME src={circus_seal} left={14.32} top={80.01} width={10.10} />
            <FME src={table_candle_1} left={19.43} top={65.43} width={7.34} />
            <FME src={clown_sad_2} left={13.91} top={60.47} width={7.92} />
            <FME src={bear_on_ball} left={42.97} top={59.88} width={5.52} />
            <FME src={table_candle_1} left={46.88} top={64.55} width={6.15} />
            <FME src={funny_7} left={36.93} top={73.81} width={10.94} />
            <FME src={funny_9} left={48.54} top={76.08} width={7.86} />
            <FME src={table_candle_1} left={43.02} top={77.02} width={10.00} />
            <FME src={fridge} left={-4.27} top={82.06} width={16.25} />
            <FME src={table_candle_1} left={1.98} top={91.17} width={10.00} />
            <FME src={couple_theater} left={3.70} top={69.07} width={6.04} />
            <FME src={creature_angry} left={21.72} top={81.91} width={6.09} />
            <FME src={drama_critic} left={26.04} top={84.46} width={6.72} />
            <FME src={skunk} left={23.85} top={64.19} width={11.30} />
            <FME src={dog_47} left={37.60} top={67.47} width={4.79} />
            <FME src={director_pleased} left={51.67} top={57.99} width={5.42} />
            <FME src={funny_6} left={38.39} top={81.11} width={8.91} />
            <FME src={buffalo} left={35.78} top={90.44} width={11.15} />
            <FME src={funny_8} left={58.44} top={80.38} width={10.52} />
            <FME src={audience_2} left={46.67} top={82.49} width={59.01} />
        </div>
    </div>
}

function FME (props: {
    src: string,
    top: number,
    left: number,
    width: number,
    class ?: string,
}) {
    const src = props.src;
    const t = props.top;
    const l = props.left;
    const w = props.width;
    const c = props.class !== undefined ? props.class : '';
    return <img src={src} className={'pos-abs ' + c} style={{
        top: t + "%", 
        left: l + "%", 
        width: w + "%"
    }} />
}